"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeTxAuxiliaryData = void 0;
const internal_1 = require("../../types/internal");
const assert_1 = require("../../utils/assert");
const serialize_1 = require("../../utils/serialize");
function serializeTxAuxiliaryData(auxiliaryData) {
    const auxiliaryDataTypesEncoding = {
        [internal_1.TxAuxiliaryDataType.ARBITRARY_HASH]: 0x00,
        [internal_1.TxAuxiliaryDataType.CATALYST_REGISTRATION]: 0x01,
    };
    switch (auxiliaryData.type) {
        case internal_1.TxAuxiliaryDataType.ARBITRARY_HASH: {
            return Buffer.concat([
                serialize_1.uint8_to_buf(auxiliaryDataTypesEncoding[auxiliaryData.type]),
                serialize_1.hex_to_buf(auxiliaryData.hashHex),
            ]);
        }
        case internal_1.TxAuxiliaryDataType.CATALYST_REGISTRATION: {
            return Buffer.concat([
                serialize_1.uint8_to_buf(auxiliaryDataTypesEncoding[auxiliaryData.type]),
            ]);
        }
        default:
            assert_1.unreachable(auxiliaryData);
    }
}
exports.serializeTxAuxiliaryData = serializeTxAuxiliaryData;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHhBdXhpbGlhcnlEYXRhLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2ludGVyYWN0aW9ucy9zZXJpYWxpemF0aW9uL3R4QXV4aWxpYXJ5RGF0YS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSxtREFBMEQ7QUFDMUQsK0NBQWdEO0FBQ2hELHFEQUFnRTtBQUVoRSxTQUFnQix3QkFBd0IsQ0FDcEMsYUFBb0M7SUFFcEMsTUFBTSwwQkFBMEIsR0FBRztRQUMvQixDQUFDLDhCQUFtQixDQUFDLGNBQWMsQ0FBQyxFQUFFLElBQUk7UUFDMUMsQ0FBQyw4QkFBbUIsQ0FBQyxxQkFBcUIsQ0FBQyxFQUFFLElBQUk7S0FDM0MsQ0FBQTtJQUVWLFFBQVEsYUFBYSxDQUFDLElBQUksRUFBRTtRQUM1QixLQUFLLDhCQUFtQixDQUFDLGNBQWMsQ0FBQyxDQUFDO1lBQ3JDLE9BQU8sTUFBTSxDQUFDLE1BQU0sQ0FBQztnQkFDakIsd0JBQVksQ0FBQywwQkFBMEIsQ0FBQyxhQUFhLENBQUMsSUFBSSxDQUFZLENBQUM7Z0JBQ3ZFLHNCQUFVLENBQUMsYUFBYSxDQUFDLE9BQU8sQ0FBQzthQUNwQyxDQUFDLENBQUE7U0FDTDtRQUNELEtBQUssOEJBQW1CLENBQUMscUJBQXFCLENBQUMsQ0FBQztZQUM1QyxPQUFPLE1BQU0sQ0FBQyxNQUFNLENBQUM7Z0JBQ2pCLHdCQUFZLENBQUMsMEJBQTBCLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBWSxDQUFDO2FBQzFFLENBQUMsQ0FBQTtTQUNMO1FBQ0Q7WUFDSSxvQkFBVyxDQUFDLGFBQWEsQ0FBQyxDQUFBO0tBQzdCO0FBQ0wsQ0FBQztBQXZCRCw0REF1QkMifQ==